export default "__VITE_ASSET__CFKhDQYp__"